// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullChampionshipResultTableEntry,
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';

// Types
type $Props = $Translate & {
  item: $FullChampionshipResultTableEntry | $ModelUpsertParams<'ChampionshipResultTableEntry'>;
  resourceData: Array<$Model<'RegattaEntry'>>;
};

const ChampionshipResultTableEntryFieldsView = function ({
  item,
  resourceData,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Regatta entry')}
            name={'RegattaEntryId'}
            required
            type={'select'}
            value={item.RegattaEntryId}
          >
            {item.RegattaEntryId === '' && (
              <option />
            )}
            {resourceData.map((i) => (
              <option
                key={i.id}
                value={i.id}
              >
                {`${i.RegistrationNo} ${i.Name || ''}`}
              </option>
            ))}
          </AvField>
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Name override')}
            name={'NameOverride'}
            value={item.NameOverride}
          />
        </Col>
      </Row>
    </>
  );
};

export default ChampionshipResultTableEntryFieldsView;
